export const buildQueryParam = (key, value) => {
	if (value !== undefined) {
		return `&${key}=${value}`
	}
	return ''
}

export const serializeQuery = data => {
	if (!data) {
		return ''
	}
	let query = ''
	Object.keys(data).map(key => {
		query += buildQueryParam(key, data[key])
		return null
	})
	return query
}
